import _Container from "@material-ui/core/esm/Container";
import _Card from "@material-ui/core/esm/Card";
import _TablePagination from "@material-ui/core/esm/TablePagination";
import _TableContainer from "@material-ui/core/esm/TableContainer";
import _Table from "@material-ui/core/esm/Table";
import _TableBody from "@material-ui/core/esm/TableBody";
import _TableRow from "@material-ui/core/esm/TableRow";
import _Checkbox from "@material-ui/core/esm/Checkbox";
import _TableCell from "@material-ui/core/esm/TableCell";
import _get from "lodash/get";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from 'react';
import { SearchNotFound } from "./SearchNotFound";
import { TableHead } from "./TableHead";
import { TableToolbar } from "./TableToolbar";
import { TableOptions } from "./TableOptions";
import { TableTop } from "./TableTop";
import { useStyles } from "./TableStyles";
import { getComparator, applySortFilter } from "../../utils/table";
import { tableProps } from "./types";

var _ref3 = /*#__PURE__*/_jsx(_TableCell, {
  colSpan: 6
});

function Table(props) {
  const _props$mainKey = props.mainKey,
        mainKey = _props$mainKey === void 0 ? '_id' : _props$mainKey,
        _onSelectItems = props.onSelectItems,
        _props$data = props.data,
        data = _props$data === void 0 ? [] : _props$data,
        _props$columns = props.columns,
        columns = _props$columns === void 0 ? [] : _props$columns,
        _props$configProps = props.configProps,
        configProps = _props$configProps === void 0 ? {} : _props$configProps,
        searchValue = props.searchValue;
  const _configProps$filters = configProps.filters,
        filters = _configProps$filters === void 0 ? [] : _configProps$filters,
        _configProps$topTable = configProps.topTable,
        topTable = _configProps$topTable === void 0 ? {} : _configProps$topTable,
        actions = configProps.actions,
        dots = configProps.dots,
        _configProps$tableSty = configProps.tableStyles,
        tableStyles = _configProps$tableSty === void 0 ? {} : _configProps$tableSty,
        _configProps$selected = configProps.selectedOptions,
        selectedOptions = _configProps$selected === void 0 ? {
    checkboxHidden: false,
    selectedIcon: null,
    selectedTooltip: null
  } : _configProps$selected,
        _configProps$filterPr = configProps.filterProp,
        filterProp = _configProps$filterPr === void 0 ? null : _configProps$filterPr;
  const _tableStyles$tableCon = tableStyles.tableContainer,
        tableContainer = _tableStyles$tableCon === void 0 ? '' : _tableStyles$tableCon,
        _tableStyles$tableHea = tableStyles.tableHeadStyles,
        tableHeadStyles = _tableStyles$tableHea === void 0 ? '' : _tableStyles$tableHea,
        _tableStyles$tableToo = tableStyles.tableToolbarStyles,
        tableToolbarStyles = _tableStyles$tableToo === void 0 ? '' : _tableStyles$tableToo,
        _tableStyles$tableRow = tableStyles.tableRowStyles,
        tableRowStyles = _tableStyles$tableRow === void 0 ? '' : _tableStyles$tableRow;
  const classes = useStyles();

  const _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        page = _useState2[0],
        setPage = _useState2[1];

  const _useState3 = useState('asc'),
        _useState4 = _slicedToArray(_useState3, 2),
        order = _useState4[0],
        setOrder = _useState4[1];

  const _useState5 = useState([]),
        _useState6 = _slicedToArray(_useState5, 2),
        selected = _useState6[0],
        setSelected = _useState6[1];

  const _useState7 = useState(_get(columns, [0, 'key'])),
        _useState8 = _slicedToArray(_useState7, 2),
        orderBy = _useState8[0],
        setOrderBy = _useState8[1];

  const _useState9 = useState(_get(filters, [0, 'key']) || filterProp),
        _useState10 = _slicedToArray(_useState9, 2),
        filterProperty = _useState10[0],
        setFilterProperty = _useState10[1];

  const _useState11 = useState(''),
        _useState12 = _slicedToArray(_useState11, 2),
        filteredValue = _useState12[0],
        setFilteredValue = _useState12[1];

  const _useState13 = useState(5),
        _useState14 = _slicedToArray(_useState13, 2),
        rowsPerPage = _useState14[0],
        setRowsPerPage = _useState14[1];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = filteredData.map(n => n[mainKey]);
      setSelected(newSelecteds);
      return;
    }

    setSelected([]);
  };

  const checkItem = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilter = event => {
    setFilteredValue(event.target.value);
  };

  useEffect(() => {
    setFilteredValue(searchValue);
    return () => setFilteredValue('');
  }, [searchValue]);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;
  const filteredData = applySortFilter(data, getComparator(order, orderBy), filteredValue, filterProperty);
  const isDataNotFound = filteredData.length === 0;

  const onChangeFilterBy = e => {
    const value = e.target.value;
    setFilterProperty(value);
  };

  const renderCell = row => {
    const items = [];
    let columnCopy = [...columns];
    columnCopy.forEach(column => {
      for (const _ref of Object.entries(row)) {
        var _ref2 = _slicedToArray(_ref, 2);

        const key = _ref2[0];
        const value = _ref2[1];

        if (key === column.key) {
          items.push(_jsx(_TableCell, {
            align: column.align ? column.align : 'left'
          }, "".concat(row[mainKey], "-").concat(key), value));
        }
      }
    });
    columnCopy.pop();
    return items;
  };

  return _jsx(_Container, {}, void 0, React.createElement(TableTop, topTable), _jsx(_Card, {
    className: "".concat(classes.tableCardContainer, " ").concat(tableContainer)
  }, void 0, _jsx(TableToolbar, {
    filters: filters,
    numSelected: selected.length,
    filteredValue: filteredValue,
    onFilter: handleFilter,
    filterProperty: filterProperty,
    onChangeFilterBy: onChangeFilterBy,
    onSelectItems: () => _onSelectItems && _onSelectItems(selected),
    selectedOptions: selectedOptions,
    tableToolbarStyles: tableToolbarStyles
  }), _jsx(_TableContainer, {}, void 0, _jsx(_Table, {}, void 0, _jsx(TableHead, {
    order: order,
    orderBy: orderBy,
    headLabel: columns,
    rowCount: data.length,
    numSelected: selected.length,
    onRequestSort: handleRequestSort,
    onSelectAllClick: handleSelectAllClick,
    tableHeadStyles: tableHeadStyles,
    checkboxHidden: selectedOptions.checkboxHidden
  }), _jsx(_TableBody, {}, void 0, filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
    const id = row[mainKey];
    const isItemSelected = selected.indexOf(id) !== -1;
    return _jsx(_TableRow, {
      hover: true,
      tabIndex: -1,
      role: "checkbox",
      selected: isItemSelected,
      "aria-checked": isItemSelected,
      classes: {
        selected: classes.selected
      },
      className: "".concat(tableRowStyles)
    }, id, !selectedOptions.checkboxHidden && _jsx(_TableCell, {
      padding: "checkbox"
    }, void 0, _jsx(_Checkbox, {
      checked: isItemSelected,
      onChange: event => checkItem(event, id),
      color: "primary"
    })), renderCell(row), !_get(actions, 'hidden', false) && _jsx(_TableCell, {
      align: "center"
    }, void 0, _jsx(TableOptions, {
      actions: actions,
      item: row,
      dots: dots
    })));
  }), emptyRows > 0 && _jsx(_TableRow, {
    style: {
      height: 53 * emptyRows
    }
  }, void 0, _ref3)), isDataNotFound && _jsx(_TableBody, {}, void 0, _jsx(_TableRow, {}, void 0, _jsx(_TableCell, {
    align: "center",
    colSpan: 6,
    className: classes.cellNotFound
  }, void 0, _jsx(SearchNotFound, {
    searchQuery: filteredValue
  })))))), _jsx(_TablePagination, {
    rowsPerPageOptions: [5, 10, 25],
    component: "div",
    count: data.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })));
}

export { Table };